if (!window.FEATURES) {
	window.FEATURES = {};
}

(function() {
	var testNode = document.createElement('div');
	var i;
	var prefixes = ['', '-webkit-', '-moz-', '-ms-'];
	for (i = 0; i < prefixes.length; i++) {
		try {
			testNode.style.position = p + 'sticky';
		} catch (e) {}
		if (testNode.style.position != '') {
			window.FEATURES.sticky = true;
			break;
		}
	}
})();

window.addScript = function(src) {
	var script = document.createElement('script');
	script.setAttribute('src', src);
	var currentScript = document.getElementsByTagName('script')[0];
	currentScript.parentNode.insertBefore(script, currentScript);
};
